import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductRecommendationActions, ProductRecommendationApiService } from '@product/data-access/v2';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class ProductRecommendationEffects {
  loadProductRecommendation$: Observable<
    | ProductRecommendationActions.ProductRecommendationLoadSuccess
    | ProductRecommendationActions.ProductRecommendationLoadFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductRecommendationActions.LOAD_PRODUCT_RECOMMENDATION),
      map((action: ProductRecommendationActions.ProductRecommendationLoad) => action.payload),
      switchMap((baseStoreCode) => {
        return this.productRecommendationApiService.getProductRecommendationData(baseStoreCode).pipe(
          map((res) => new ProductRecommendationActions.ProductRecommendationLoadSuccess(res)),
          catchError((error: unknown) => of(new ProductRecommendationActions.ProductRecommendationLoadFail(error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private productRecommendationApiService: ProductRecommendationApiService,
  ) {}
}
